import { defineStore } from 'pinia'

import type { AssignmentEditorStore } from './interfaces'

import { actions } from './actions'
import { exerciseActions } from './exercise-actions'
import { getters } from './getters'

/** The assignment editor's working document — READING chapters or MATH exercises. Pure state: no
 *  requests, no parsing. */
export const useAssignmentEditorStore = defineStore('assignment-editor', {
  state: (): AssignmentEditorStore => ({
    templateId: null,
    title: '',
    type: null,
    status: null,
    disciplineCode: null,
    grade: null,
    coverPath: null,
    coverUrl: null,
    curriculumTopicId: null,
    curriculumLessonId: null,
    taxonomyLabels: null,
    workingDocument: null,
    pristine: null,
    selectedChapterId: null,
    selectedExerciseId: null,
    promptTab: 'editor',
    mediaUrls: {},
    mediaExpiresAt: null,
    validationIssues: null,
    loading: false,
    saving: false,
  }),
  actions: {
    ...actions,
    ...exerciseActions,
  },
  getters,
})
